"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/headerSection.tsx */

import { LandingSiteTemplateGetDataMenuOutputApiModel } from "@/Apis/ClinicApi";
import { LanguageSelector, SmartImage, SmartLink } from "@/Components";
import { useResponsive } from "@/Hooks";
import { DarkModeToggle } from "../../Components";
import HeaderNav from "../../Components/HeaderNav";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode, MouseEventHandler } from "react";

type HeaderSectionSupport3sItem = {
    key: Key | null | undefined;
    /** Detected variants: "support-item mb-3" | "support-item" */
    className: string;
    /** Detected variants: "isax isax-messages-3" | "isax isax-call-calling" */
    i0ClassName: string;
    /** Detected variants: "info@example.com" | "+1 24565 89856" */
    h50Text: ReactNode;
    /** Detected variants: "General Inquiries" | "Emergency Cases" */
    p0Text: ReactNode;
    /** Detected variants: "avatar avatar-lg bg-primary rounded-circle" */
    div0ClassName?: string;
    /** Detected variants: "link" */
    h50ClassName?: string;
    /** Detected variants: "title" */
    p0ClassName?: string;
};

type HeaderSectionDivs2Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-youtube" | "fa-brands fa-linkedin-in" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};

type HeaderSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Monday - Friday : 8:30 AM to 6:30 PM" | "+1 80001 54569" */
    pText: ReactNode;
    /** Detected variants: "isax isax-clock me-1" | "isax isax-call me-1" */
    className: string;
};

type HeaderSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "ENG" | "ARA" | "FRA" */
    link0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/flags/us-flag.svg" | "/Templates/Doccure/img/flags/arab-flag.svg" | "/Templates/Doccure/img/flags/france-flag.svg" */
    src: string;
    /** Detected variants: "dropdown-item rounded d-flex align-items-center" */
    className?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "flag" */
    alt?: string;
    /** Detected variants: "me-2" */
    imageWithBasePath0ClassName?: string;
};

type HeaderSectionUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "social-icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeFourHeaderSectionGeneratedProps = {
    menus: LandingSiteTemplateGetDataMenuOutputApiModel[];
    isScrolled?: boolean;
    onMobileBtn?: MouseEventHandler<HTMLAnchorElement>;
    onMenuClose?: MouseEventHandler<HTMLAnchorElement>;
    /** Default: false */
    divDiv0Div0Div0Ul0Li1Div0Link0LinkAriaExpanded?: boolean;
    /** Default: "dropdown" */
    divDiv0Div0Div0Ul0Li1Div0Link0LinkDataBsToggle?: string;
    /** Default: "#" */
    divDiv0Div0Div0Ul0Li1Div0Link0LinkHref?: string;
    /** Default: "ENG" */
    divDiv0Div0Div0Ul0Li1Div0Link0LinkText?: ReactNode;
    divDiv1H50H5Props?: Partial<ComponentProps<"h5">> | ((item: HeaderSectionSupport3sItem) => Partial<ComponentProps<"h5">>);
    /** Default: "#" */
    divHeader0Div0Nav0Div0Link0LinkHref?: string;
    /** Default: "mobile_btn" */
    divHeader0Div0Nav0Div0Link0LinkId?: string;
    divHeader0Div0Nav0Div0Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.home" */
    divHeader0Div0Nav0Div0Link1LinkHref?: string;
    divHeader0Div0Nav0Div0Link1LinkVisible?: boolean;
    divHeader0Div0Nav0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-04.svg" */
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageSrc?: string;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageVisible?: boolean;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "all_routes.home" */
    divHeader0Div0Nav0Div1Div0Link0LinkHref?: string;
    divHeader0Div0Nav0Div1Div0Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-04.svg" */
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc?: string;
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    divHeader0Div0Nav0Div1Div0Link1LinkHref?: string;
    /** Default: "menu_close" */
    divHeader0Div0Nav0Div1Div0Link1LinkId?: string;
    divHeader0Div0Nav0Div1Div0Link1LinkVisible?: boolean;
    divHeader0Div0Nav0Div1Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Contact Information" */
    divHeader0Div0Nav0Div1Div1Div0H30H3Text?: ReactNode;
    divHeader0Div0Nav0Div1Div1Div0H30H3Visible?: boolean;
    divHeader0Div0Nav0Div1Div1Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div1Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Follow Us" */
    divHeader0Div0Nav0Div1Div1Div1H30H3Text?: ReactNode;
    divHeader0Div0Nav0Div1Div1Div1H30H3Visible?: boolean;
    divHeader0Div0Nav0Div1Div1Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div1Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "all_routes.login" */
    divHeader0Div0Nav0Div1Div1Div2Link0LinkHref?: string;
    /** Default: "Sign In" */
    divHeader0Div0Nav0Div1Div1Div2Link0LinkText?: ReactNode;
    divHeader0Div0Nav0Div1Div1Div2Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Div1Div1Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div1Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.register" */
    divHeader0Div0Nav0Div1Div1Div2Link1LinkHref?: string;
    /** Default: "Sign Up" */
    divHeader0Div0Nav0Div1Div1Div2Link1LinkText?: ReactNode;
    divHeader0Div0Nav0Div1Div1Div2Link1LinkVisible?: boolean;
    divHeader0Div0Nav0Div1Div1Div2Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div1Div2Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    divHeader0Div0Nav0Ul0Li0Link0LinkHref?: string;
    /** Default: "dark-mode-toggle" */
    divHeader0Div0Nav0Ul0Li0Link0LinkId?: string;
    /** Default: "#" */
    divHeader0Div0Nav0Ul0Li0Link1LinkHref?: string;
    /** Default: "light-mode-toggle" */
    divHeader0Div0Nav0Ul0Li0Link1LinkId?: string;
    /** Default: "search_popup" */
    divHeader0Div0Nav0Ul0Li1Link0LinkAriaControls?: string;
    /** Default: "#search_popup" */
    divHeader0Div0Nav0Ul0Li1Link0LinkDataBsTarget?: string;
    /** Default: "offcanvas" */
    divHeader0Div0Nav0Ul0Li1Link0LinkDataBsToggle?: string;
    /** Default: "#" */
    divHeader0Div0Nav0Ul0Li1Link0LinkHref?: string;
    divHeader0Div0Nav0Ul0Li1Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Ul0Li1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Ul0Li1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.booking" */
    divHeader0Div0Nav0Ul0Li2Link0LinkHref?: string;
    divHeader0Div0Nav0Ul0Li2Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Ul0Li2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Ul0Li2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Book Appointment" */
    divHeader0Div0Nav0Ul0Li2Link0Span0SpanText?: ReactNode;
    /** Default: "#support_item" */
    divHeader0Div0Nav0Ul0Li3Link0LinkDataBsTarget?: string;
    /** Default: "offcanvas" */
    divHeader0Div0Nav0Ul0Li3Link0LinkDataBsToggle?: string;
    /** Default: "#" */
    divHeader0Div0Nav0Ul0Li3Link0LinkHref?: string;
    divHeader0Div0Nav0Ul0Li3Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Ul0Li3Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Ul0Li3Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderSectionDivs2Item) => Partial<ComponentProps<typeof SmartLink>>);
    headerSectionSupport3s: HeaderSectionSupport3sItem[];
    headerSectionDivs2: HeaderSectionDivs2Item[];
    headerSectionDivs: HeaderSectionDivsItem[];
    headerSectionUls: HeaderSectionUlsItem[];
    headerSectionUls2: HeaderSectionUls2Item[];
    headerSectionSupport3sItemWrapper?: (item: HeaderSectionSupport3sItem, content: ReactNode) => ReactNode;
    headerSectionSupport3sRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionSupport3sH5Visible?: boolean;
    headerSectionSupport3sH5Renderer?: (item: HeaderSectionSupport3sItem, defaultNode: ReactNode) => ReactNode;
    headerSectionSupport3sH5Props?: Partial<ComponentProps<"h5">> | ((item: HeaderSectionSupport3sItem) => Partial<ComponentProps<"h5">>);
    headerSectionDivs2ItemWrapper?: (item: HeaderSectionDivs2Item, content: ReactNode) => ReactNode;
    headerSectionDivs2Renderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionDivs2LinkVisible?: boolean;
    headerSectionDivs2LinkRenderer?: (item: HeaderSectionDivs2Item, defaultNode: ReactNode) => ReactNode;
    headerSectionDivs2LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderSectionDivs2Item) => Partial<ComponentProps<typeof SmartLink>>);
    headerSectionDivsItemWrapper?: (item: HeaderSectionDivsItem, content: ReactNode) => ReactNode;
    headerSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionUlsItemWrapper?: (item: HeaderSectionUlsItem, content: ReactNode) => ReactNode;
    headerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionUls2ItemWrapper?: (item: HeaderSectionUls2Item, content: ReactNode) => ReactNode;
    headerSectionUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionUls2LinkVisible?: boolean;
    headerSectionUls2LinkRenderer?: (item: HeaderSectionUls2Item, defaultNode: ReactNode) => ReactNode;
    headerSectionUls2LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeFourHeaderSectionGenerated: FC<HomeFourHeaderSectionGeneratedProps> = ({
    menus,
    isScrolled,
    onMobileBtn,
    onMenuClose,
    divDiv0Div0Div0Ul0Li1Div0Link0LinkAriaExpanded = false,
    divDiv0Div0Div0Ul0Li1Div0Link0LinkDataBsToggle = "dropdown",
    divDiv0Div0Div0Ul0Li1Div0Link0LinkHref = "#",
    divDiv0Div0Div0Ul0Li1Div0Link0LinkText = "ENG",
    divHeader0Div0Nav0Div0Link0LinkHref = "#",
    divHeader0Div0Nav0Div0Link0LinkId = "mobile_btn",
    divHeader0Div0Nav0Div0Link0LinkVisible,
    divHeader0Div0Nav0Div0Link0LinkRenderer,
    divHeader0Div0Nav0Div0Link0LinkProps,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageAlt = "Logo",
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-04.svg",
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageVisible,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageRenderer,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageProps,
    divHeader0Div0Nav0Div0Link1LinkHref = "all_routes.home",
    divHeader0Div0Nav0Div0Link1LinkVisible,
    divHeader0Div0Nav0Div0Link1LinkRenderer,
    divHeader0Div0Nav0Div0Link1LinkProps,
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt = "Logo",
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-04.svg",
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible,
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer,
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageProps,
    divHeader0Div0Nav0Div1Div0Link0LinkHref = "all_routes.home",
    divHeader0Div0Nav0Div1Div0Link0LinkVisible,
    divHeader0Div0Nav0Div1Div0Link0LinkRenderer,
    divHeader0Div0Nav0Div1Div0Link0LinkProps,
    divHeader0Div0Nav0Div1Div0Link1LinkHref = "#",
    divHeader0Div0Nav0Div1Div0Link1LinkId = "menu_close",
    divHeader0Div0Nav0Div1Div0Link1LinkVisible,
    divHeader0Div0Nav0Div1Div0Link1LinkRenderer,
    divHeader0Div0Nav0Div1Div0Link1LinkProps,
    divHeader0Div0Nav0Div1Div1Div0H30H3Text = "Contact Information",
    divHeader0Div0Nav0Div1Div1Div0H30H3Visible,
    divHeader0Div0Nav0Div1Div1Div0H30H3Renderer,
    divHeader0Div0Nav0Div1Div1Div0H30H3Props,
    divHeader0Div0Nav0Div1Div1Div1H30H3Text = "Follow Us",
    divHeader0Div0Nav0Div1Div1Div1H30H3Visible,
    divHeader0Div0Nav0Div1Div1Div1H30H3Renderer,
    divHeader0Div0Nav0Div1Div1Div1H30H3Props,
    divHeader0Div0Nav0Div1Div1Div2Link0LinkHref = "all_routes.login",
    divHeader0Div0Nav0Div1Div1Div2Link0LinkText = "Sign In",
    divHeader0Div0Nav0Div1Div1Div2Link0LinkVisible,
    divHeader0Div0Nav0Div1Div1Div2Link0LinkRenderer,
    divHeader0Div0Nav0Div1Div1Div2Link0LinkProps,
    divHeader0Div0Nav0Div1Div1Div2Link1LinkHref = "all_routes.register",
    divHeader0Div0Nav0Div1Div1Div2Link1LinkText = "Sign Up",
    divHeader0Div0Nav0Div1Div1Div2Link1LinkVisible,
    divHeader0Div0Nav0Div1Div1Div2Link1LinkRenderer,
    divHeader0Div0Nav0Div1Div1Div2Link1LinkProps,
    divHeader0Div0Nav0Ul0Li0Link0LinkHref = "#",
    divHeader0Div0Nav0Ul0Li0Link0LinkId = "dark-mode-toggle",
    divHeader0Div0Nav0Ul0Li0Link1LinkHref = "#",
    divHeader0Div0Nav0Ul0Li0Link1LinkId = "light-mode-toggle",
    divHeader0Div0Nav0Ul0Li1Link0LinkAriaControls = "search_popup",
    divHeader0Div0Nav0Ul0Li1Link0LinkDataBsTarget = "#search_popup",
    divHeader0Div0Nav0Ul0Li1Link0LinkDataBsToggle = "offcanvas",
    divHeader0Div0Nav0Ul0Li1Link0LinkHref = "#",
    divHeader0Div0Nav0Ul0Li1Link0LinkVisible,
    divHeader0Div0Nav0Ul0Li1Link0LinkRenderer,
    divHeader0Div0Nav0Ul0Li1Link0LinkProps,
    divHeader0Div0Nav0Ul0Li2Link0LinkHref = "all_routes.booking",
    divHeader0Div0Nav0Ul0Li2Link0LinkVisible,
    divHeader0Div0Nav0Ul0Li2Link0LinkRenderer,
    divHeader0Div0Nav0Ul0Li2Link0LinkProps,
    divHeader0Div0Nav0Ul0Li2Link0Span0SpanText = "Book Appointment",
    divHeader0Div0Nav0Ul0Li3Link0LinkDataBsTarget = "#support_item",
    divHeader0Div0Nav0Ul0Li3Link0LinkDataBsToggle = "offcanvas",
    divHeader0Div0Nav0Ul0Li3Link0LinkHref = "#",
    divHeader0Div0Nav0Ul0Li3Link0LinkVisible,
    divHeader0Div0Nav0Ul0Li3Link0LinkRenderer,
    divHeader0Div0Nav0Ul0Li3Link0LinkProps,
    divDiv1H50H5Props,
    liLink0LinkProps,
    linkLinkProps,
    headerSectionSupport3s,
    headerSectionDivs2,
    headerSectionDivs,
    headerSectionUls,
    headerSectionUls2,
    headerSectionSupport3sItemWrapper,
    headerSectionSupport3sRenderer,
    headerSectionSupport3sH5Visible,
    headerSectionSupport3sH5Renderer,
    headerSectionSupport3sH5Props,
    headerSectionDivs2ItemWrapper,
    headerSectionDivs2Renderer,
    headerSectionDivs2LinkVisible,
    headerSectionDivs2LinkRenderer,
    headerSectionDivs2LinkProps,
    headerSectionDivsItemWrapper,
    headerSectionDivsRenderer,
    headerSectionUlsItemWrapper,
    headerSectionUlsRenderer,
    headerSectionUls2ItemWrapper,
    headerSectionUls2Renderer,
    headerSectionUls2LinkVisible,
    headerSectionUls2LinkRenderer,
    headerSectionUls2LinkProps,
}) => {
    const { isMobile } = useResponsive();
    return (
        <div className="main-header">
            <div className="header-topbar header-topbar-four">
                <div className="container">
                    <div className="topbar-info">
                        <div className="header-info">
                            {renderCollectionNode(
                                headerSectionDivs,
                                (item: HeaderSectionDivsItem) => (
                                    <p key={item.key}>
                                        <i className={item.className} />
                                        {item.pText}
                                    </p>
                                ),
                                headerSectionDivsItemWrapper,
                                headerSectionDivsRenderer
                            )}
                        </div>
                        <ul>
                            <li className="social-header">
                                <div className="social-icon">
                                    {renderCollectionNode(
                                        headerSectionDivs2,
                                        (item: HeaderSectionDivs2Item) => (
                                            renderItemNode(headerSectionDivs2LinkVisible, headerSectionDivs2LinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} {...(typeof headerSectionDivs2LinkProps === "function" ? headerSectionDivs2LinkProps(item) : (headerSectionDivs2LinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                    <i className={item.className} />
                                                </SmartLink>
                                            ))
                                        ),
                                        headerSectionDivs2ItemWrapper,
                                        headerSectionDivs2Renderer
                                    )}
                                </div>
                            </li>
                            <li className="drop-header">
                                <LanguageSelector iconOnly={isMobile} />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <header className={isScrolled ? "header header-four home-menu fixed pharmacy-header" : "header header-four home-menu"}>
                <div className="container">
                    <nav className="navbar navbar-expand-lg header-nav">
                        <div className="navbar-header">
                            {renderNode(divHeader0Div0Nav0Div0Link0LinkVisible, divHeader0Div0Nav0Div0Link0LinkRenderer, (
                                <SmartLink id={divHeader0Div0Nav0Div0Link0LinkId} href={divHeader0Div0Nav0Div0Link0LinkHref} onClick={onMobileBtn} {...(divHeader0Div0Nav0Div0Link0LinkProps ?? {})}>
                                    <i className="fa-solid fa-bars" />
                                </SmartLink>
                            ))}
                            {renderNode(divHeader0Div0Nav0Div0Link1LinkVisible, divHeader0Div0Nav0Div0Link1LinkRenderer, (
                                <SmartLink href={divHeader0Div0Nav0Div0Link1LinkHref} className="navbar-brand logo" {...(divHeader0Div0Nav0Div0Link1LinkProps ?? {})}>
                                    {renderNode(divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageVisible, divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageSrc} className="img-fluid" alt={divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageAlt} {...(divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </SmartLink>
                            ))}
                        </div>
                        <div className="main-menu-wrapper">
                            <div className="menu-header">
                                {renderNode(divHeader0Div0Nav0Div1Div0Link0LinkVisible, divHeader0Div0Nav0Div1Div0Link0LinkRenderer, (
                                    <SmartLink href={divHeader0Div0Nav0Div1Div0Link0LinkHref} className="menu-logo" {...(divHeader0Div0Nav0Div1Div0Link0LinkProps ?? {})}>
                                        {renderNode(divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible, divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc} className="img-fluid" alt={divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt} {...(divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </SmartLink>
                                ))}
                                {renderNode(divHeader0Div0Nav0Div1Div0Link1LinkVisible, divHeader0Div0Nav0Div1Div0Link1LinkRenderer, (
                                    <SmartLink id={divHeader0Div0Nav0Div1Div0Link1LinkId} className="menu-close" href={divHeader0Div0Nav0Div1Div0Link1LinkHref} onClick={onMenuClose} {...(divHeader0Div0Nav0Div1Div0Link1LinkProps ?? {})}>
                                        <i className="fas fa-times" />
                                    </SmartLink>
                                ))}
                            </div>
                            <HeaderNav menus={menus} />
                            <div className="header-items">
                                <div className="about-popup-item border-0 pb-0">
                                    {renderNode(divHeader0Div0Nav0Div1Div1Div0H30H3Visible, divHeader0Div0Nav0Div1Div1Div0H30H3Renderer, (
                                        <h3 className="title" {...(divHeader0Div0Nav0Div1Div1Div0H30H3Props ?? {})}>{divHeader0Div0Nav0Div1Div1Div0H30H3Text}</h3>
                                    ))}
                                    {renderCollectionNode(
                                        headerSectionSupport3s,
                                        (item: HeaderSectionSupport3sItem) => (
                                            <div className={item.className} key={item.key}>
                                                <div className={item.div0ClassName ?? "avatar avatar-lg bg-primary rounded-circle"}>
                                                    <i className={item.i0ClassName} />
                                                </div>
                                                <div>
                                                    <p className={item.p0ClassName ?? "title"}>{item.p0Text}</p>
                                                    {renderItemNode(headerSectionSupport3sH5Visible, headerSectionSupport3sH5Renderer, item, (
                                                        <h5 className={item.h50ClassName ?? "link"} {...(typeof headerSectionSupport3sH5Props === "function" ? headerSectionSupport3sH5Props(item) : (headerSectionSupport3sH5Props ?? {}))} {...(typeof divDiv1H50H5Props === "function" ? divDiv1H50H5Props(item) : (divDiv1H50H5Props ?? {}))}>{item.h50Text}</h5>
                                                    ))}
                                                </div>
                                            </div>
                                        ),
                                        headerSectionSupport3sItemWrapper,
                                        headerSectionSupport3sRenderer
                                    )}
                                </div>
                                <div className="about-popup-item border-0 pb-0">
                                    {renderNode(divHeader0Div0Nav0Div1Div1Div1H30H3Visible, divHeader0Div0Nav0Div1Div1Div1H30H3Renderer, (
                                        <h3 className="title" {...(divHeader0Div0Nav0Div1Div1Div1H30H3Props ?? {})}>{divHeader0Div0Nav0Div1Div1Div1H30H3Text}</h3>
                                    ))}
                                    <ul className="d-flex align-items-center gap-2 social-iyem">
                                        {renderCollectionNode(
                                            headerSectionUls2,
                                            (item: HeaderSectionUls2Item) => (
                                                <li key={item.key}>
                                                    {renderItemNode(headerSectionUls2LinkVisible, headerSectionUls2LinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "social-icon"} {...(typeof headerSectionUls2LinkProps === "function" ? headerSectionUls2LinkProps(item) : (headerSectionUls2LinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>
                                                            <i className={item.className} />
                                                        </SmartLink>
                                                    ))}
                                                </li>
                                            ),
                                            headerSectionUls2ItemWrapper,
                                            headerSectionUls2Renderer
                                        )}
                                    </ul>
                                </div>
                                <div className="header-items-button">
                                    {renderNode(divHeader0Div0Nav0Div1Div1Div2Link0LinkVisible, divHeader0Div0Nav0Div1Div1Div2Link0LinkRenderer, (
                                        <SmartLink href={divHeader0Div0Nav0Div1Div1Div2Link0LinkHref} className="btn btn-primary" {...(divHeader0Div0Nav0Div1Div1Div2Link0LinkProps ?? {})}>
                                            <i className="isax isax-lock-1 me-2" />
                                            {divHeader0Div0Nav0Div1Div1Div2Link0LinkText}
                                        </SmartLink>
                                    ))}
                                    {renderNode(divHeader0Div0Nav0Div1Div1Div2Link1LinkVisible, divHeader0Div0Nav0Div1Div1Div2Link1LinkRenderer, (
                                        <SmartLink href={divHeader0Div0Nav0Div1Div1Div2Link1LinkHref} className="btn btn-dark" {...(divHeader0Div0Nav0Div1Div1Div2Link1LinkProps ?? {})}>
                                            <i className="isax isax-user-tick4 me-2" />
                                            {divHeader0Div0Nav0Div1Div1Div2Link1LinkText}
                                        </SmartLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <ul className="nav header-navbar-rht">
                            <li className="header-theme">
                                <DarkModeToggle mode="inverted" />
                            </li>
                            <li>
                                {renderNode(divHeader0Div0Nav0Ul0Li1Link0LinkVisible, divHeader0Div0Nav0Ul0Li1Link0LinkRenderer, (
                                    <SmartLink href={divHeader0Div0Nav0Ul0Li1Link0LinkHref} className="search-btn" tabIndex={-1} data-bs-toggle={divHeader0Div0Nav0Ul0Li1Link0LinkDataBsToggle} data-bs-target={divHeader0Div0Nav0Ul0Li1Link0LinkDataBsTarget} aria-controls={divHeader0Div0Nav0Ul0Li1Link0LinkAriaControls} {...(divHeader0Div0Nav0Ul0Li1Link0LinkProps ?? {})}>
                                        <i className="isax isax-search-normal-1" />
                                    </SmartLink>
                                ))}
                            </li>
                            <li>
                                {renderNode(divHeader0Div0Nav0Ul0Li2Link0LinkVisible, divHeader0Div0Nav0Ul0Li2Link0LinkRenderer, (
                                    <SmartLink href={divHeader0Div0Nav0Ul0Li2Link0LinkHref} className="btn btn-secondary" {...(divHeader0Div0Nav0Ul0Li2Link0LinkProps ?? {})}>
                                        <i className="isax isax-calendar-tick5" />
                                        <span>{divHeader0Div0Nav0Ul0Li2Link0Span0SpanText}</span>
                                    </SmartLink>
                                ))}
                            </li>
                            <li>
                                {renderNode(divHeader0Div0Nav0Ul0Li3Link0LinkVisible, divHeader0Div0Nav0Ul0Li3Link0LinkRenderer, (
                                    <SmartLink href={divHeader0Div0Nav0Ul0Li3Link0LinkHref} className="details-btn" data-bs-toggle={divHeader0Div0Nav0Ul0Li3Link0LinkDataBsToggle} data-bs-target={divHeader0Div0Nav0Ul0Li3Link0LinkDataBsTarget} {...(divHeader0Div0Nav0Ul0Li3Link0LinkProps ?? {})}>
                                        <i className="isax isax-menu-14" />
                                    </SmartLink>
                                ))}
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
        </div>
    );
};

export default HomeFourHeaderSectionGenerated;
